<template>
  <div class="fluid white event-index-page mb-0 pb-5">
    <div class="elevation-3 fluid primary white--text green-pattern">
      <v-container fluid-md>
        <v-layout row wrap grid-list-md>
          <v-flex class="mt-5 mb-md-5" text-md-left text-xs-left xs12 md4>
            <h1 class="fluid primary h2">Events Gallery</h1>
          </v-flex>
          <v-flex class="my-5 pt-4" text-md-right text-xs-left xs12 md6 offset-xs0 offset-md2>
            <p class="fluid primary">
              Part of TD Lab's mission is help build and grow the next generation
              of innovators. We do this through a number of sponsorships, programs
              and community outreach events each year that provide us the ability to
              achieve three main goals: support access and retention of
              underrepresented communities in STEM, engage with the communities in
              which we work, live and play, and meet potential candidates for our
              co-op internship program.
            </p>
            <p class="fluid primary">
              Here are some of the places we’ve been this past year.
            </p>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <v-toolbar class="w-100 elevation-5 event-toolbar mx-auto" fixed>
      <div class="w-100">
        <v-container
          class="py-2 hidden-md-and-up w-100 filter-button-container"
          justify-center
          align-center
        >
          <v-layout row wrap class="py-0">
            <v-flex class="py-0" xs12 md6>
              <v-btn color="primary w-100" small @click="filterDrawer = !filterDrawer">
                <span v-if="!filterDrawer">Filter events</span>
                <span v-if="filterDrawer">Hide Filters</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container
          class="w-100 px-0 hidden-sm-and-down"
          :class="{
            'py-1': $vuetify.breakpoint.mdAndDown,
            'py-2': $vuetify.breakpoint.mdAndUp,
            'active-filter-drawer': filterDrawer
          }"
        >
          <v-layout row wrap justify-center align-center>
            <v-flex xs12 md5>
              <v-btn-toggle
                class="w-100 event-filter-button-group elevation-2"
                :class="{
                  'pt-0': $vuetify.breakpoint.xs,
                  'my-2': $vuetify.breakpoint.md,
                  'my-2': toggle_exclusive !== 1
                }"
                v-model="toggle_exclusive"
                mandatory
              >
                <v-btn
                  flat
                  v-for="(type, index) in viewTypesMeta"
                  :key="type.title"
                  class="flex event-filter-button"
                  :value="index"
                >
                  <span class="icon">{{ type.icon }}</span>
                  {{ type.title }}
                </v-btn>
              </v-btn-toggle>
            </v-flex>
            <v-flex
              xs8
              md5
              offset-md2
              v-if="toggle_exclusive === 1"
              :class="{
                'pt-3': $vuetify.breakpoint.mdAndDown,
                'pt-1': $vuetify.breakpoint.mdAndUp
              }"
            >
              <v-text-field label="Search Events..." v-model="search" outline></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </v-toolbar>
    <div class="fluid">
      <v-container grid-list-md>
        <v-layout row wrap text-md-left class="mt-5" v-if="toggle_exclusive == 1">
          <v-flex
            v-for="(event, index) in filteredEventsSorted"
            :key="`${event.title}${index}`"
            xs12
            sm6
            md4
            lg4
            xl3
          >
            <v-hover>
              <v-card
                class="event-page-event"
                :color="index % 2 ? 'grey lighten-2' : 'primary'"
                :dark="!(index % 2)"
                :class="`elevation-${hover ? 12 : 0}`"
                slot-scope="{ hover }"
                :to="`/event/${event.uri}`"
              >
                <v-flex class="content w-100 px-3">
                  <div class="bg-img top-left">
                    <img :src="event.imageFeatured" />
                  </div>
                  <div class="bg-img top-right">
                    <img :src="event.imageFeatured" />
                  </div>
                  <div class="bg-img bottom-left">
                    <img :src="event.imageFeatured" />
                  </div>
                  <div class="bg-img bottom-right">
                    <img :src="event.imageFeatured" />
                  </div>
                </v-flex>
                <v-flex class="content description w-100">
                  <h3 class="mb-0">{{ event.title }}</h3>
                  <h4 class="mb-0">{{ event.start }}</h4>
                  <p>{{ event.eventDescription }}</p>
                </v-flex>
              </v-card>
            </v-hover>
          </v-flex>
        </v-layout>
        <v-layout
          class="buttons-group"
          align-center
          justify-center
          row
          v-if="toggle_exclusive == 0"
        >
          <v-btn @click="prevMonth" class="mx-2 my-2" fab dark color="primary">
            <v-icon dark>arrow_back</v-icon>
          </v-btn>
          <span>
            <h3>{{ dateRange }}</h3>
          </span>
          <v-btn @click="nextMonth" class="mx-2 my-2" fab dark color="primary">
            <v-icon dark>arrow_forward</v-icon>
          </v-btn>
        </v-layout>
        <v-layout v-if="toggle_exclusive == 0">
          <v-flex class="my-2">
            <v-card round class="elevation-2">
              <calendar
                style="height: 800px"
                view="month"
                ref="eventsCalendar"
                :schedules="newEvents"
                :theme="theme"
                :month="month"
                :disableDblClick="disableDblClick"
                :isReadOnly="isReadOnly"
                :taskView="true"
                :useDetailPopup="useDetailPopup"
                :calendars="calendarList"
                @clickSchedule="onClickSchedule"
              />
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<style lang="scss">
.event-index-page {
  h1 {
    font-size: 3em;
  }
  .h2:after,
  h2:after {
    content: "—";
    display: block;
    line-height: 1em;
  }
  .green-pattern {
    z-index: 0;
    h1 {
      display: inline;
    }
  }
  h3 {
    font-size: xx-large !important;
  }
  .buttons-group {
    align-items: baseline;
  }
  .event-page-event {
    position: relative;
    padding-top: 70%;
    @media only screen and (min-width: 600px) {
      padding-top: 70% !important;
      .content.description {
        padding-left: 32px !important;
      }
    }
    @media only screen and (min-width: 960px) {
      padding-top: 134% !important;
    }
    @media only screen and (min-width: 1264px) {
      padding-top: 100% !important;
    }
    background: red;
    .content {
      position: absolute;
      top: 0;
      height: 100%;
      overflow: hidden;
      &.description {
        padding-left: 30px !important;
        padding-right: 30px !important;
        padding-top: 21% !important;
        h3 {
          text-align: left;
          font-size: 3em;
          width: 80%;
          line-height: 1em;
          margin-bottom: -0.25em !important;
          &:after {
            content: "—";
            display: block;
          }
        }
        p {
          width: 100%;
          text-align: left;
          opacity: 0;
          transform: translateY(0px);
          transition-delay: 0.2s;
        }
      }
      .bg-img {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0.2;
        filter: saturate(0) brightness(0.7) contrast(3);
        width: 100%;
        height: 100%;
        background-size: 180% 180%;
        object-fit: cover;
        overflow: hidden;
        img {
          position: absolute;
          top: -50%;
          left: -50%;
          width: 140%;
        }
        &.top-left {
          top: -50%;
          left: -50%;
          transition-delay: 0.15s;
          img {
            top: 50%;
            left: 50%;
          }
        }
        &.top-right {
          top: -50%;
          left: 50%;
          transition-delay: 0s;
          img {
            top: 50%;
            left: -50%;
          }
        }
        &.bottom-left {
          top: 50%;
          left: -50%;
          transition-delay: 0.05s;
          img {
            top: -50%;
            left: 50%;
          }
        }
        &.bottom-right {
          top: 50%;
          left: 50%;
          transition-delay: 0.1s;
          img {
            top: -50%;
            left: -50%;
          }
        }
      }
    }
    * {
      transition: all 0.5s ease;
      transform: translate3d(0, 0, 0);
    }
    &:hover {
      .bg-img {
        filter: saturate(1) brightness(0.5) contrast(1);
        opacity: 0.4;
        &.top-left {
          top: -95%;
          left: -50%;
        }
        &.top-right {
          top: -50%;
          left: 95%;
        }
        &.bottom-left {
          top: 50%;
          left: -95%;
        }
        &.bottom-right {
          top: 95%;
          left: 50%;
        }
      }
      .description p {
        opacity: 1;
        transform: translateY(20px);
      }
    }
  }
  .active-filter-drawer {
    display: block !important;
    flex: none;
  }
  .filter-button-container {
    flex: none;
    display: block;
  }
  .event-filter-button-group {
    background-color: transparent;
    .v-btn:before {
      background-color: transparent;
    }
    .v-btn--active:before {
      background-color: #f5f5f5 !important;
    }
    .event-filter-button {
      height: 100%;
      min-height: 50px;
      padding: 0;
      .icon {
        font-size: 1.5em;
        display: block;
        width: 100%;
        margin-bottom: 0.0125em;
      }
      .v-btn__content {
        display: block;
      }
    }
  }
  .event-toolbar {
    .v-toolbar__content {
      height: auto !important;
      z-index: 1;
    }
    position: sticky;
    height: auto !important;
  }
}
</style>

<script>
import 'tui-calendar/dist/tui-calendar.css'
import { Calendar } from '@toast-ui/vue-calendar'
import 'tui-date-picker/dist/tui-date-picker.css'
import 'tui-time-picker/dist/tui-time-picker.css'
import { db } from '@/db.js'
import { sortBy } from 'lodash'

export default {
  name: 'eventsIndex',
  components: {
    calendar: Calendar
  },
  data () {
    return {
      menu: [{ title: 'TD', url: 'https://www.td.com/to-our-customers/' }],
      events: [],
      filteredEvents: [],
      filterDrawer: false,
      dateRange: '',
      search: '',
      calendarList: [
        {
          id: '0',
          name: 'events',
          color: '#fff',
          bgColor: '#34b233',
          borderColor: '#34b233'
        }
      ],
      viewTypesMeta: [
        {
          title: 'Calendar View',
          icon: '📅'
        },
        {
          title: 'List View',
          icon: '🗒️'
        }
      ],
      toggle_exclusive: 1,
      theme: {
        'month.dayname.height': '30px',
        'month.dayname.borderLeft': '1px solid #ffffff',
        'month.dayname.textAlign': 'center',
        'week.today.color': '#333',
        'week.daygridLeft.width': '100px',
        'week.timegridLeft.width': '100px',
        'common.border': '1px solid #e5e5e5',
        'common.backgroundColor': 'white',
        'common.holiday.color': '#ff4040',
        'common.saturday.color': '#333',
        'common.dayname.color': '#333',
        'common.today.color': '#66fc03'
      },
      month: {
        visibleWeeksCount: 4,
        startDayOfWeek: 1
      },
      disableDblClick: true,
      isReadOnly: true,
      useDetailPopup: true
    }
  },
  computed: {
    filteredEventsSorted () {
      return sortBy(this.filteredEvents, 'createdAt').reverse()
    },
    newEvents () {
      var newEvents = []
      this.events.map(event => {
        newEvents.push({
          start: event.start,
          end: event.end,
          id: event.uri,
          body: event.eventDescription,
          isAllDay: true,
          location: event.eventLocation,
          title: event.title,
          dueDateClass: '',
          category: 'allday',
          calendarId: '0'
        })
      })
      return newEvents
    },
    getDate () {
      const today = new Date()
      const dd = String(today.getDate()).padStart(2, '0')
      const mm = String(today.getMonth() + 1).padStart(2, '0')
      const yyyy = today.getFullYear()

      return yyyy + '-' + mm + '-' + dd
    }
  },
  watch: {
    toggle_exclusive: function (toggleValue) {
      if (toggleValue === 1) {
        return
      }
      this.setRenderRangeText()
    },
    search: function () {
      this.filteredEvents = this.events.filter(event => {
        return event.title.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  methods: {
    clear: function () {},
    setRenderRangeText: function () {
      const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
      ]
      this.$nextTick(() => {
        const calDate = this.$refs['eventsCalendar'].invoke('getDate')
        let year = calDate.getFullYear()
        let month = monthNames[calDate.getMonth()]
        this.dateRange = `${month} ${year}`
      })
    },
    onClickSchedule (event) {
      this.$router.push(`/event/${event.schedule.id}`)
    },
    nextMonth: function () {
      this.$refs['eventsCalendar'].invoke('next')
      this.setRenderRangeText()
    },
    prevMonth: function () {
      this.$refs.eventsCalendar.invoke('prev')
      this.setRenderRangeText()
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.filteredEvents = this.events
    })
  },
  firestore: {
    events: db
      .collection('events')
      .orderBy('start')
      .limit(25)
  }
}
</script>
